import { z } from "zod";

export const assessorResetPasswordSchema = z.object({
  password: z.string().min(8),
});

export type AssessorResetPassword = z.infer<typeof assessorResetPasswordSchema>;
